import { MuseumState } from "@/store/types/museum.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import Artist from '@/models/artist';

export const state: MuseumState = {
    artists: [],
    artworks: [],
    loading: false,
};

const namespaced = true;

export const MuseumModule: Module<MuseumState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}